



































import Vue from 'vue';
import { Game } from '@/game/model';
import Score from '@/components/Score.vue';
import { isGameLost, isGameWon } from '@/game/scoring';

const placeholder = {
  guess: [undefined, undefined, undefined, undefined],
  score: undefined
};

const getRows = (game: Game) =>
  [
    ...(Array(Math.max(0, 10 - game.plays.length))).fill(placeholder),
    ...game.plays.slice(0, 10).map((play) => ({
        guess: [...play.guess, ...Array(4 - play.guess.length)
          .fill(placeholder)],
        score: play.score
      }))
      .reverse()
  ];

export default Vue.component('GameBoard', {
  props: ['game', 'submitGuess', 'canSubmitGuess', 'removePiece'],
  components: {
    Score
  },
  computed: {
    rows() {
      return getRows(this.$props.game);
    },
    gameOver() {
      return isGameWon(this.$props.game) || isGameLost(this.$props.game);
    }
  }
});
